import { pgTable, serial, text, integer, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const complianceItemsTable = pgTable("compliance_items", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id").notNull(),
  requirement: text("requirement").notNull(),
  category: text("category", { enum: ["technical", "financial", "legal", "admin"] }).notNull().default("admin"),
  status: text("status", { enum: ["pending", "ready", "missing"] }).notNull().default("pending"),
  owner: text("owner"),
  notes: text("notes"),
  assignedToUserId: integer("assigned_to_user_id"),
  assignedToName: text("assigned_to_name"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertComplianceItemSchema = createInsertSchema(complianceItemsTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertComplianceItem = z.infer<typeof insertComplianceItemSchema>;
export type ComplianceItem = typeof complianceItemsTable.$inferSelect;
